import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table table-striped my-4" }
const _hoisted_2 = { class: "thead-dark" }
const _hoisted_3 = { class: "table-width-150" }
const _hoisted_4 = { class: "table-wdith-150" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.dailyReport.timeSlot')), 1),
        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('views.dailyReport.seatNumber')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('common.owner.surName')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('common.owner.givenName')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.dailyReport.accessibilityRequired')), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketsWithSeatNumber(), (ticket, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", null, _toDisplayString(_ctx.formatTicketTime(ticket)), 1),
          _createElementVNode("td", _hoisted_4, _toDisplayString(ticket.seatNumber), 1),
          _createElementVNode("td", null, _toDisplayString(ticket.lastName), 1),
          _createElementVNode("td", null, _toDisplayString(ticket.firstName), 1),
          _createElementVNode("td", null, _toDisplayString(ticket.accessibility ? _ctx.$t('common.true') : _ctx.$t('common.false')), 1)
        ]))
      }), 128))
    ])
  ]))
}